"use strict";

import * as utils from '../util/browser.util';

function init() {
	$('a[data-ads-cat]').on('click', function(){
		let evtTarget = $(this);
		let adsCat = evtTarget.data('ads-cat');
		let adsLabel = evtTarget.data('ads-label');
		let adsUrl = evtTarget.attr('href');
		utils.trackEvent(adsCat, 'click', `${adsLabel} - ${adsUrl}`, 1);
	});
}

module.exports = {
	init
};


// WEBPACK FOOTER //
// ./src/scripts/client/plugin/ads.js